// /rf-admin/tenants — 顧客テナント一覧
// UI 复刻 /dashboard:Card + Table + Badge + PageTitle(globals.css の .card / .table 样式)
// 行为独立:RfAdminApp shell 保留深紫底色(导航区分),page content 用浅色 Card

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { rfAdminListTenants, type RfTenant } from "../api/admin";
import { Card } from "../../components/ui/Card";
import { Table, type TableColumn } from "../../components/ui/Table";
import { Badge } from "../../components/ui/Badge";
import { PageTitle } from "../../components/ui/PageTitle";

const STATUS_COLOR: Record<string, "green" | "gray" | "red" | "yellow"> = {
  active: "green",
  suspended: "gray",
  deleted: "red",
};

const STATUS_LABEL: Record<string, string> = {
  active: "稼働中",
  suspended: "停止中",
  deleted: "削除済み",
};

export function RfAdminTenants() {
  const [tenants, setTenants] = useState<RfTenant[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    rfAdminListTenants()
      .then((t) => {
        if (cancelled) return;
        setTenants(t);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e.message || "読み込み失敗");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const columns: TableColumn<RfTenant>[] = [
    {
      key: "company_name",
      header: "会社名",
      render: (t) => <Link to={`/rf-admin/tenants/${t.id}`}>{t.company_name}</Link>,
    },
    { key: "contract_type", header: "契約種別", render: (t) => t.contract_type },
    { key: "contract_start", header: "契約開始", render: (t) => t.contract_start ?? "—" },
    { key: "contract_end", header: "契約終了", render: (t) => t.contract_end ?? "—" },
    {
      key: "status",
      header: "状態",
      render: (t) => (
        <Badge color={STATUS_COLOR[t.status] ?? "gray"} dot>
          {STATUS_LABEL[t.status] ?? t.status}
        </Badge>
      ),
    },
  ];

  const newButton = (
    <Link to="/rf-admin/tenants/new" className="btn btn-primary">
      <Plus size={16} style={{ marginRight: 6, verticalAlign: "middle" }} />
      新規作成
    </Link>
  );

  if (error) {
    return (
      <div className="rf-admin-page">
        <PageTitle title="Tenants" subtitle="登録済み顧客テナント一覧" actions={newButton} />
        <Card>
          <div className="login-error">{error}</div>
        </Card>
      </div>
    );
  }
  if (tenants === null) {
    return (
      <div className="rf-admin-page">
        <PageTitle title="Tenants" subtitle="登録済み顧客テナント一覧" actions={newButton} />
        <Card>
          <p>読み込み中...</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="rf-admin-page">
      <PageTitle title="Tenants" subtitle="登録済み顧客テナント一覧" actions={newButton} />
      <Card>
        <Table<RfTenant>
          columns={columns}
          data={tenants}
          rowKey={(t) => String(t.id)}
          emptyText="まだテナントがありません。「新規作成」から始めてください。"
        />
      </Card>
    </div>
  );
}